//GreenIQ

import greeniqbg from '../static/img/costumers/GreenIQ/pic-project-1.jpg';
import greeniqmobilebg from '../static/img/costumers/GreenIQ/pattiBlack38177Unsplash.png'
import greeniqdescriptionimage from '../static/img/costumers/GreenIQ/hubs.png'
import greeniquxdesignimage from '../static/img/costumers/GreenIQ/axures-small.png'
import greeniquxdesignmobileimage from '../static/img/costumers/GreenIQ/uxdesignmobile.png'
import greeniquxdesignimageabove from '../static/img/costumers/GreenIQ/group-11-copy-2.png'
import greeniquxdesignimageunder from '../static/img/costumers/GreenIQ/group-11-copy-3.png'
import greeniquidesignimage from '../static/img/costumers/GreenIQ/device-small.png'
import greeniquidesignmobileimage from '../static/img/costumers/GreenIQ/uidesignmobile.png'
import greeniquidesignarrowimagenew from '../static/img/costumers/GreenIQ/path.png'
import greeniqfooterbackground from '../static/img/costumers/GreenIQ/bg-pic.png'
import greeniqfootermobilebackground from '../static/img/costumers/GreenIQ/mobileBgPic.png'
import greeniqprojectcoverbackgroundmobileimage from '../static/img/costumers/GreenIQ/projectcovermobile.png'
import greeniqprojectcoverbackgroundimage from '../static/img/costumers/GreenIQ/pic-project-1.jpg'


//Telll

import telllbg from '../static/img/costumers/Telll/pic-project-1.jpg'
import telllmobilebg from '../static/img/costumers/Telll/group11.png'
import tellldescriptionimage from '../static/img/costumers/Telll/telll.png'
import tellluxdesignimage from '../static/img/costumers/Telll/axures-small.png'
import tellluxdesignmobileimage from '../static/img/costumers/Telll/uxdesignmobile.png'
import tellluxdesignimageabove from '../static/img/costumers/Telll/group-11-copy-6.png'
import tellluidesignimage from '../static/img/costumers/Telll/green-1.png'
import tellluidesignmobileimage from '../static/img/costumers/Telll/uidesignmobile.png'
import tellluidesignarrowimagenew from '../static/img/costumers/Telll/path.png'
import telllfooterbackground from '../static/img/costumers/Telll/bg-pic.png'
import telllfootermobilebackground from '../static/img/costumers/Telll/mobileBgPic.png'
import telllprojectcoverbackgroundmobileimage from '../static/img/costumers/Telll/projectcovermobile.png'
import telllprojectcoverbackgroundimage from '../static/img/costumers/Telll/pic-project-1.jpg'

//GoTit

import gotitbg from '../static/img/costumers/Gotit/pic-project-1.jpg'
import gotitmobilebg from '../static/img/costumers/Gotit/group11.png'
import gotitdescriptionimage from '../static/img/costumers/Gotit/group-10.png'
import gotituxdesignimage from '../static/img/costumers/Gotit/axures-small-copy.png'
import gotituxdesignmobileimage from '../static/img/costumers/Gotit/uxdesignmobile.png'
import gotituxdesignimageabove from '../static/img/costumers/Gotit/group-11-copy-7.png'
import gotituidesignimage from '../static/img/costumers/Gotit/group-6.png'
import gotituidesignmobileimage from '../static/img/costumers/Gotit/uidesignmobile.png'
import gotituidesignarrowimagenew from '../static/img/costumers/Gotit/path.png'
import gotitfooterbackground from '../static/img/costumers/Gotit/bg-pic.png'
import gotitfootermobilebackground from '../static/img/costumers/Gotit/mobileBgPic.png'
import gotitprojectcoverbackgroundmobileimage from '../static/img/costumers/Gotit/projectcovermobile.png'
import gotitprojectcoverbackgroundimage from '../static/img/costumers/Gotit/pic-project-1.jpg'

//Pods

import podsbg from '../static/img/costumers/Pods/pic-project-1.jpg'
import podsmobilebg from '../static/img/costumers/Pods/group11.png'
import podsdescriptionimage from '../static/img/costumers/Pods/group-2.png'
import podsuxdesignimage from '../static/img/costumers/Pods/ux.png'
import podsuxdesignmobileimage from '../static/img/costumers/Pods/uxdesignmobile.png'
import podsuxdesignimageabove from '../static/img/costumers/Pods/group-11.png'
import podsuxdesignimageunder from '../static/img/costumers/Pods/group-11-copy.png'
import podsuidesignimage from '../static/img/costumers/Pods/phones.png'
import podsuidesignmobileimage from '../static/img/costumers/Pods/uidesignmobile.png'
import podsuidesignarrowimagenew from '../static/img/costumers/Pods/path.png'
import podsiconsimage from '../static/img/costumers/Pods/icons.png'
import podsfooterbackground from '../static/img/costumers/Pods/bg-pic.png'
import podsfootermobilebackground from '../static/img/costumers/Pods/mobileBgPic.png'
import podsprojectcoverbackgroundmobileimage from '../static/img/costumers/Pods/projectcovermobile.png'
import podsprojectcoverbackgroundimage from '../static/img/costumers/Pods/pic-project-1.jpg'

//tiivii

import tiiviibg from '../static/img/costumers/TiiVii/pic-project-1.jpg'
import tiiviimobilebg from '../static/img/costumers/TiiVii/mobilebg.png'
import tiiviidescriptionimage from '../static/img/costumers/TiiVii/group-12.png'
import tiiviiuxdesignimage from '../static/img/costumers/TiiVii/axures.png'
import tiiviiuxdesignmobileimage from '../static/img/costumers/TiiVii/uxdesignmobile.png'
import tiiviiuxdesignimageabove from '../static/img/costumers/TiiVii/group-11-copy-4.png'
import tiiviiuidesignimage from '../static/img/costumers/TiiVii/phones.png'
import tiiviiuidesignmobileimage from '../static/img/costumers/TiiVii/uidesignmobile.png'
import tiiviiuidesignarrowimagenew from '../static/img/costumers/TiiVii/icon-right-arrow-1.png'
import tiiviifooterbackground from '../static/img/costumers/TiiVii/bg-pic.png'
import tiiviifootermobilebackground from '../static/img/costumers/TiiVii/mobileBgPic.png'
import tiiviiprojectcoverbackgroundmobileimage from '../static/img/costumers/TiiVii/projectcovermobile.png'
import tiiviiprojectcoverbackgroundimage from '../static/img/costumers/TiiVii/pic-project-1.jpg'

//WITH

import withbg from '../static/img/costumers/With/pic-project-1.jpg'
import withmobilebg from '../static/img/costumers/With/group12.png'
import withdescriptionimage from '../static/img/costumers/With/devices.png'
import withuxdesignimage from '../static/img/costumers/With/ux.png'
import withuxdesignmobileimage from '../static/img/costumers/With/uxdesignmobile.png'
import withuxdesignimageabove from '../static/img/costumers/With/group-11-copy-2.png'
import withuxdesignimageunder from '../static/img/costumers/With/group-11-copy-3.png'
import withuidesignimage from '../static/img/costumers/With/phones.png'
import withuidesignmobileimage from '../static/img/costumers/With/uidesignmobile.png'
import withuidesignarrowimagenew from '../static/img/costumers/With/icon-right-arrow-1.png'
import withfooterbackground from '../static/img/costumers/With/bg-pic.png'
import withfootermobilebackground from '../static/img/costumers/With/mobileBgPic.png'
import withprojectcoverbackgroundmobileimage from '../static/img/costumers/With/projectcovermobile.png'
import withprojectcoverbackgroundimage from '../static/img/costumers/With/pic-project-1.jpg'

//Cattle Watch

import cattleWatchbg from '../static/img/costumers/Cattle/pic-project-1.jpg'
import cattlewatchmobilebg from '../static/img/costumers/Cattle/group11.png'
import cattleWatchdescriptionimage from '../static/img/costumers/Cattle/noun-1046432.png'
import cattleWatchuxdesignimage from '../static/img/costumers/Cattle/axures-small.png'
import cattleWatchuxdesignmobileimage from '../static/img/costumers/Cattle/uxdesignmobile.png'
import cattleWatchuxdesignimageabove from '../static/img/costumers/Cattle/group-11-copy-6.png'
import cattleWatchuidesignimage from '../static/img/costumers/Cattle/green-1.png'
import cattleWatchuidesignmobileimage from '../static/img/costumers/Cattle/uidesignmobile.png'
import cattleWatchuidesignarrowimagenew from '../static/img/costumers/Cattle/path.png'
import cattleWatchfooterbackground from '../static/img/costumers/Cattle/bg-pic.png'
import cattleWatchfootermobilebackground from '../static/img/costumers/Cattle/mobileBgPic.png'
import cattlewatchprojectcoverbackgroundmobileimage from '../static/img/costumers/Cattle/projectcovermobile.png'
import cattlewatchprojectcoverbackgroundimage from '../static/img/costumers/Cattle/pic-project-1.jpg'

//Amdocs

import amdocsbg from '../static/img/costumers/Amdocs/pic-project-1.jpg'
import amdocsmobilebg from '../static/img/costumers/Amdocs/group9.png'
import amdocsdescriptionimage from '../static/img/costumers/Amdocs/illustartion.png'
import amdocsuxdesignimage from '../static/img/costumers/Amdocs/illustartion.png'
import amdocsuxdesignmobileimage from '../static/img/costumers/Amdocs/uxuidesinmobile.png'
import amdocsuxdesignimageabove from '../static/img/costumers/Amdocs/group-11-copy-8.png'
import amdocsuidesignarrowimagenew from '../static/img/costumers/Amdocs/path.png'
import amdocsfooterbackground from '../static/img/costumers/Amdocs/bg-pic.png'
import amdocsfootermobilebackground from '../static/img/costumers/Amdocs/mobileBgPic.png'
import amdocsprojectcoverbackgroundmobileimage from '../static/img/costumers/Amdocs/projectcovermobile.png'
import amdocsprojectcoverbackgroundimage from '../static/img/costumers/Amdocs/pic-project-1.jpg'

//Cronus

import cronusbg from '../static/img/costumers/Cronus/pic-project-1.jpg'
import cronusmobilebg from '../static/img/costumers/Cronus/group11.png'
import cronusdescriptionimage from '../static/img/costumers/Cronus/group-5.png'
import cronusuxdesignimage from '../static/img/costumers/Cronus/screen-shot-2019-01-08-at-12-38-38-copy.png'
import cronusuxdesignmobileimage from '../static/img/costumers/Cronus/uxdesignmobile.png'
import cronusuxdesignimageabove from '../static/img/costumers/Cronus/group-11-copy-7.png'
import cronusuidesignimage from '../static/img/costumers/Cronus/green-1-copy.png'
import cronusuidesignmobileimage from '../static/img/costumers/Cronus/uidesignmobile.png'
import cronusuidesignarrowimagenew from '../static/img/costumers/Cronus/path.png'
import cronusfooterbackground from '../static/img/costumers/Cronus/bg-pic.png'
import cronusfootermobilebackground from '../static/img/costumers/Cronus/mobileBgPic.png'
import cronusprojectcoverbackgroundmobileimage from '../static/img/costumers/Cronus/projectcovermobile.png'
import cronusprojectcoverbackgroundimage from '../static/img/costumers/Cronus/pic-project-1.jpg'

//ProBuild

import probuildbg from '../static/img/costumers/Probuild/pic-project-1.jpg'
import probuildmobilebg from '../static/img/costumers/Probuild/group9.png'
import probuilddescriptionimage from '../static/img/costumers/Probuild/city.png'
import probuilduxdesignimageabove from '../static/img/costumers/Probuild/group-11.png'
import probuilduidesignimage from '../static/img/costumers/Probuild/group-2.png'
import probuilduidesignmobileimage from '../static/img/costumers/Probuild/uxuidesignmobile.png'
import probuilduxdesignimageunder from '../static/img/costumers/Probuild/group-11-copy.png'
import probuilduidesignarrowimagenew from '../static/img/costumers/Probuild/path.png'
import probuildfooterbackground from '../static/img/costumers/Probuild/bg-pic.png'
import probuildfootermobilebackground from '../static/img/costumers/Probuild/mobileBgPic.png.png'
import probuildprojectcoverbackgroundmobileimage from '../static/img/costumers/Probuild/projectcovermobile.png'
import probuildprojectcoverbackgroundimage from '../static/img/costumers/Probuild/pic-project-1.jpg'

//MayTronics

import maytronicsbg from '../static/img/costumers/mytronics/pic-project-1.jpg'
import maytronicsmobilebg from '../static/img/costumers/mytronics/group9.png'
import maytronicsdescriptionimage from '../static/img/costumers/mytronics/life-wheel.png'
import maytronicsuxdesignimageabove from '../static/img/costumers/mytronics/group-11-copy-6.png'
import maytronicsuidesignimage from '../static/img/costumers/mytronics/mytronics1.png'
import maytronicsuidesignmobileimage from '../static/img/costumers/mytronics/uxuidesignmobile.png'
import maytronicsuidesignarrowimagenew from '../static/img/costumers/mytronics/path.png'
import maytronicsfooterbackground from '../static/img/costumers/mytronics/bg-pic.png'
import maytronicsfootermobilebackground from '../static/img/costumers/mytronics/mobileBgPic.png'
import maytronicsprojectcoverbackgroundmobileimage from '../static/img/costumers/mytronics/projectcovermobile.png'
import maytronicsprojectcoverbackgroundimage from '../static/img/costumers/mytronics/pic-project-1.jpg'

//IsraelToday

import israelTodaybg from '../static/img/costumers/IsraelToday/pic-project-1.jpg'
import israeltodaymobilebg from '../static/img/costumers/IsraelToday/mobile.png'
import israelTodayuidesignimage from '../static/img/costumers/IsraelToday/israelToday.png'
import israelTodayuidesignmobileimage from '../static/img/costumers/IsraelToday/uxuidesignmobile.png'
import israelTodayuidesignarrowimagenew from '../static/img/costumers/IsraelToday/path.png'
import israelTodayfooterbackground from '../static/img/costumers/IsraelToday/bg-pic.png'
import israeltodayfootermobilebackground from '../static/img/costumers/IsraelToday/mobileBgPic.png'
import israelTodayprojectcoverbackgroundmobileimage from '../static/img/costumers/IsraelToday/projectcovermobile.png'
import israelTodayprojectcoverbackgroundimage from '../static/img/costumers/IsraelToday/pic-project-1.jpg'


const data = [

  {
    "projectName": "greeniq",
    image: require("../static/img/costumers/GreenIq/green.png"),
    imageMobile: require("../static/img/costumers/GreenIq/greenm.png"),
    hoverImage: require("../static/img/costumers/GreenIq/greencover.png"),
    logo: require("../static/img/costumers/GreenIq/mobileproject.png"),
    isActive: false,
    "headerComponent": {
      "headerBackgroundImage": greeniqbg,
      "headerMobileBackgroundImage": greeniqmobilebg,
      "headerMobileBackgrounColor": "#0c1704"
    },
    "descriptionComponent": {
      "descriptionBackgroundColor": "#0c1704",
      "descriptionTitle": "THE GREEN IQ GARDEN HUB",
      "descriptionTitleColor": "#7aab53",
      "descriptionSubTitle": "Smart Garden Hub",
      "descriptionText": "The GreenIQ App controls the Smart Garden Hub product, allowing irrigation scheduling based on current and forecasted weather, garden monitoring and control. The Smart Garden Hub saves up to 50% on the outdoor water consumption, diagrams the user can look into using the app.",
      "platforms": "#UX #UI Design #Android #iOS #Desktop #Server Side",
      "descriptionImage": greeniqdescriptionimage
    },
    "uxDesign": {
      "backgroundColor": "#0f6a35",
      "titleColor": "#7aab53",
      "uxDesignImage": greeniquxdesignimage,
      "uxDesignMobileImage": greeniquxdesignmobileimage,
      "titleImageAbove": greeniquxdesignimageabove,
      "uxDesignText": "When working on GreenIQ, we put emphasis on creating flow and learning curve easy and intuitive as can be, focusing on providing the sense of control to the user. The application is very intuitive, pleasant, allowing the user to control the irrigation system at home, and get immediate information at any time without any effort from anywhere.",
      "titleImageUnder": greeniquxdesignimageunder
    },
    "uiDesign": {
      "backgroundColorLeft": "#073422",
      "backgroundColorRight": "#0a4f33",
      "titleUi": "UI",
      "titleColor": '#7aab53',
      "uiDesignImages": [
        greeniquidesignimage
      ],
      "uiDesignMobileImages": [
        greeniquidesignmobileimage
      ],
      "colorNew": "#7aab53",
      "image": greeniquidesignarrowimagenew,
      "titleImageAbove": greeniquxdesignimageabove,
      "uiDesignText": "What guided us when we started designing concepts for GreenIQ, was the importance of keeping it simple and practical, yet adding a fresh look which strengthens the application's essence. We directed user’s focus in app’s activities and actions, maintaining a tailor made warm experience using photos and creating programs in all platforms.",
      "titleImageUnder": greeniquxdesignimageunder
    },
    "uxUiDesignWide": {
      titleTextColor: "#ffffff",
      bannerImages: [
        {
          image: "/static/img/costumers/GreenIq/bannerimages/phone1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/GreenIq/bannerimages/phone2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/GreenIq/bannerimages/phone3.png",
          isActive: false
        }, {
          image: "/static/img/costumers/GreenIq/bannerimages/phone4.png",
          isActive: false
        }, {
          image: "/static/img/costumers/GreenIq/bannerimages/phone5.png",
          isActive: false
        }],
      bannerMobileImages: [
        {
          image: "/static/img/costumers/GreenIq/bannerimages/mobile/phone1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/GreenIq/bannerimages/mobile/phone2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/GreenIq/bannerimages/mobile/phone3.png",
          isActive: false
        }, {
          image: "/static/img/costumers/GreenIq/bannerimages/mobile/phone4.png",
          isActive: false
        }, {
          image: "/static/img/costumers/GreenIq/bannerimages/mobile/phone5.png",
          isActive: false
        }],
      middleBanner: {
        backgroundColor: "#f2f2f2",
        imageWeb: "/static/img/costumers/GreenIq/ux_section.svg",
        imageMobile: "/static/img/costumers/GreenIq/ux_section_mobile.svg",
        titleText: " UX DESIGN",
        titleColor: "#514077",
        text: "When working on GreenIQ, we put emphasis on creating flow and learning curve easy and intuitive as can be, focusing on providing the sense of control to the user. The application is very intuitive, pleasant, allowing the user to control the irrigation system at home, and get immediate information at any time without any effort from anywhere.",
        textColor: "#414141"
      },
      "backgroundColor": "#0a4f33",
      "title": " UI DESIGN",
      "titleColor": "#7aab53",
      "textAboveImage": "",
      "text": "What guided us when we started designing concepts for GreenIQ, was the importance \n" +
        "of keeping it simple and practical, yet adding a fresh look  which strengthens the application's essence. We directed user’s focus in app’s activities and actions, maintaining a tailor made warm experience using photos and creating programs in all platforms.",
      "textUnderImage": "",
      "images": [],
      "colorNew": "",
      "image": ""

    },
    "uiDesignWide": {
      "backgroundColor": "",
      "images": "",
      "colorNew": "",
      "image": ""
    },
    "icons": {
      "iconsImage": "",
      "backgroundColor": "",
      "iconsTitleColor": ""
    },
    "footer": {
      "footerbackgroundimage": greeniqfooterbackground,
      "footermobilebackgroundimage": greeniqfootermobilebackground
    },
    "projectCover": {
      "projectCoverBackgroundImage": greeniqprojectcoverbackgroundimage,
      projectCoverBackgroundImageLogo: require ("../static/img/costumers/GreenIq/banner-logo.svg"),
      "projectCoverBackgroundMobileImage": greeniqprojectcoverbackgroundmobileimage,
      "projectCoverUpBanner": require("../static/img/costumers/GreenIq/mobilefull.png"),

    }
  }, //5
  {
    "projectName": "Amdocs",
    image: require("../static/img/costumers/Amdocs/amdocs.png"),
    imageMobile: require("../static/img/costumers/Amdocs/amdocsm.png"),
    hoverImage: require("../static/img/costumers/Amdocs/amdocscover.png"),
    logo: require("../static/img/costumers/Amdocs/mobileproject.png"),
    isActive: false,
    "headerComponent": {
      "headerBackgroundImage": amdocsbg,
      "headerMobileBackgroundImage": amdocsmobilebg,
      "headerMobileBackgrounColor": "#3a0317",
    },
    "descriptionComponent": {
      "descriptionBackgroundColor": "#3a0317",
      "descriptionTitle": "AMDOCS WELCOME CENTER TOUCH SCREENS",
      "descriptionTitleColor": "#ef2a71",
      "descriptionSubTitle": "Touch screens",
      "descriptionText": "More than 15 web-apps for Amdocs demo center. Each web-app was displayed in huge touch screens.",
      "platforms": " #UX­ #UIdesign #web",
      "descriptionImage": amdocsdescriptionimage
    },
    "uiDesign": {
      "colorNew": "#ef2a71",
      "image": amdocsuidesignarrowimagenew
    },
    "uxUiDesignWide": {
      "backgroundColor": "#68072b",
      "title": "UX/UI DESIGN",
      "titleColor": "#ef2a71",
      titleTextColor: "#dddddd",
      bannerImages: [
        {
          image: "/static/img/costumers/Amdocs/bannerimages/screen1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/Amdocs/bannerimages/screen2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Amdocs/bannerimages/screen3.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Amdocs/bannerimages/screen4.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Amdocs/bannerimages/screen5.png",
          isActive: false
        }],
      bannerMobileImages: [
        {
          image: "/static/img/costumers/Amdocs/bannerimages/mobile/screen1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/Amdocs/bannerimages/mobile/screen2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Amdocs/bannerimages/mobile/screen3.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Amdocs/bannerimages/mobile/screen4.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Amdocs/bannerimages/mobile/screen5.png",
          isActive: false
        }],
      "textAboveImage": amdocsuxdesignimageabove,
      "text": "In this project we got the chance to get wild and be creative.  The process was different than our usual design thinking. The challenge was to convey “boring” data or " +
        "too much content by telling a different concept story for each one, yet stick " +
        "to the product’s and brand’s essense. Since we used as minimum buttons as we had, we " +
        "had to think about vary animations to go from one screen to another. We collected concepts from real world, gaming,  iOT and 3d. We built " +
        "from zero every story for each web-app, different graphic language, icons, characters, fonts and " +
        "every detail that affects the experience.",
      "textUnderImage": amdocsuxdesignimageabove,
      "images": [
        amdocsuxdesignimage
      ],
      "imagesMobile": [
        amdocsuxdesignmobileimage
      ],
      "colorNew": "#ef2a71",
      "image": amdocsuidesignarrowimagenew

    },
    "uiDesignWide": {
      "backgroundColor": "",
      "images": "",
      "colorNew": "",
      "image": ""
    },
    "icons": {
      "iconsImage": "",
      "backgroundColor": "",
      "iconsTitleColor": ""
    },
    "footer": {
      "footerbackgroundimage": amdocsfooterbackground,
      "footermobilebackgroundimage": amdocsfootermobilebackground
    },
    "projectCover": {
      "projectCoverBackgroundImage": amdocsprojectcoverbackgroundimage,
      "projectCoverBackgroundMobileImage": amdocsprojectcoverbackgroundmobileimage,
      projectCoverBackgroundImageLogo: require ("../static/img/costumers/Amdocs/banner-logo.svg"),
      "projectCoverUpBanner": require("../static/img/costumers/Amdocs/mobilefull.png")
    }
  }, // 0
  {
    "projectName": "cronus",
    image: require("../static/img/costumers/Cronus/cronus.png"),
    imageMobile: require("../static/img/costumers/Cronus/cronusm.png"),
    hoverImage: require("../static/img/costumers/Cronus/cronuscover.png"),
    logo: require("../static/img/costumers/Cronus/mobileproject.png"),
    isActive: false,
    "headerComponent": {
      "headerBackgroundImage": cronusbg,
      "headerMobileBackgroundImage": cronusmobilebg,
      "headerMobileBackgrounColor": "#0c6f96"
    },
    "descriptionComponent": {
      "descriptionBackgroundColor": "#414141",
      "descriptionTitle": "CYBER SYSTEM",
      "descriptionTitleColor": "#2bbcee",
      "descriptionSubTitle": "Cyber system",
      "descriptionText": "With the help of cronus cyber system, user can define his critical process (crm, billing, customer onboarding etc). Cybot can be deployed globally and showcase global Attack Path Scenarios™ so you can see how a hacker can jump from a workstation in the UK to a router in Germany to a database in the US.",
      "platforms": "#UX/UI design #desktop",
      "descriptionImage": cronusdescriptionimage
    },
    "uxDesign": {
      "backgroundColor": "#095573",
      "titleColor": "#2bbcee",
      "uxDesignImage": cronusuxdesignimage,
      "uxDesignMobileImage": cronusuxdesignmobileimage,
      "titleImageAbove": cronusuxdesignimageabove,
      "uxDesignText": "We joined to complex B2B system that was designed by managers and developers with no UX understanding. The project needed constant meetings with PM’s, marketing, analysts and CTO to understand the system, the pain points and provide creative solutions for all different users (with different permissions), convey information in simple and understandable way (’cause not all users are professionals in this area) and build data visualization.",
      "titleImageUnder": cronusuxdesignimageabove
    },
    "uiDesign": {
      "colorNew": "#2bbcee",
      "image": cronusuidesignarrowimagenew
    },
    "uxUiDesignWide": {
      titleTextColor: "#FFFFFF",
      bannerImages: [
        {
          image: "/static/img/costumers/Cronus/bannerimages/screen1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/Cronus/bannerimages/screen2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Cronus/bannerimages/screen3.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Cronus/bannerimages/screen4.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Cronus/bannerimages/screen5.png",
          isActive: false
        }],
      bannerMobileImages: [
        {
          image: "/static/img/costumers/Cronus/bannerimages/mobile/phone1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/Cronus/bannerimages/mobile/phone2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Cronus/bannerimages/mobile/phone3.png",
          isActive: false
        }],
      middleBanner: {
        backgroundColor: "#f2f2f2",
        imageWeb: "/static/img/costumers/Cronus/ux_section.png",
        imageMobile: "/static/img/costumers/Cronus/ux_section_mobile.png",
        titleText: " UX DESIGN",
        titleColor: "#514077",
        text: "When we started planning the structure of Cronus, we understood that combining an ecommerce site with a social network generates a lot of information and functions that need to be placed correctly on the app screens, avoiding overload. To overcome the information load we used a simple menu, an intuitive flow, icons to guide the user, and an easy to learn structure",
        textColor: "#414141"
      },
      "backgroundColor": "#063f56",
      "title": " UI DESIGN",
      "titleColor": "#2bbcee",
      "textAboveImage": cronusuxdesignimageabove,
      "text": "Complex systems have a lot of table designs and too much data. The challenge was to make the design modern, brand oriented, pixel perfect, create clear guidestyles for developers, interesting layout, explore the world of data visualization and apply.",
      "textUnderImage": cronusuxdesignimageabove,
      "images": [cronusuidesignimage],
      "imagesMobile": [cronusuidesignmobileimage],
      "colorNew": "#2bbcee",
      "image": cronusuidesignarrowimagenew

    },
    "uiDesignWide": {
      "backgroundColor": "",
      "images": "",
      "colorNew": "",
      "image": ""
    },
    "icons": {
      "iconsImage": "",
      "backgroundColor": "",
      "iconsTitleColor": ""
    },
    "footer": {
      "footerbackgroundimage": cronusfooterbackground,
      "footermobilebackgroundimage": cronusfootermobilebackground
    },
    "projectCover": {
      "projectCoverBackgroundImage": cronusprojectcoverbackgroundimage,
      projectCoverBackgroundImageLogo: require ("../static/img/costumers/Cronus/banner-logo.svg"),
      "projectCoverBackgroundMobileImage": cronusprojectcoverbackgroundmobileimage,
      "projectCoverUpBanner": require("../static/img/costumers/Cronus/mobilefull.png")
    }
  }, //9
  {
    "projectName": "pods",
    image: require("../static/img/costumers/Pods/pods.png"),
    imageMobile: require("../static/img/costumers/Pods/podsm.png"),
    hoverImage: require("../static/img/costumers/Pods/podscover.png"),
    logo: require("../static/img/costumers/Pods/mobileproject.png"),
    isActive: false,
    "headerComponent": {
      "headerBackgroundImage": podsbg,
      "headerMobileBackgroundImage": podsmobilebg,
      "headerMobileBackgrounColor": "#161619"
    },
    "descriptionComponent": {
      "descriptionBackgroundColor": "#414041",
      "descriptionTitle": "TIME FOR PODCAST",
      "descriptionTitleColor": "#f2b761",
      "descriptionSubTitle": "Mobile app design",
      "descriptionText": "Podcasts is a rising media, Over the last decade, the number of podcast listeners has increased steadily, with double-digit growth each year.",
      "platforms": " #UX­ #UI design #Android #iOS #LOGO",
      "descriptionImage": podsdescriptionimage
    },
    "uxDesign": {
      "backgroundColor": "#41414a",
      "titleColor": "#f2b761",
      "uxDesignImage": podsuxdesignimage,
      "uxDesignMobileImage": podsuxdesignmobileimage,
      "titleImageAbove": podsuxdesignimageabove,
      "uxDesignText": "Our main goal was to create a lean and friendly flow for the onboarding and an instant ‘live view’ button that can immediately connect the user to his door camera and decide how to proceed. We understand the importance of user’s privacy and the sense of control and security from anywhere.",
      "titleImageUnder": podsuxdesignimageunder
    },
    "uiDesign": {
      "backgroundColorLeft": "#222229",
      "backgroundColorRight": "#2b2b32",
      "titleUi": "UI",
      "titleColor": '#f2b761',
      "uiDesignImages": [
        podsuidesignimage
      ],
      "uiDesignMobileImages": [
        podsuidesignmobileimage
      ],
      "colorNew": "#f2b761",
      "image": podsuidesignarrowimagenew,
      "titleImageAbove": podsuxdesignimageabove,
      "uiDesignText": "Like vinyl and cd covers, Podcast maker love their podcast covers. There are many kind of podcast covers, most of them are very artistic, its make the visual of podcasts very special. When we started to design the App, we wanted to emphasize the entertainment of listening to podcast. \n" +
        "The challenge was to stay simple and clear to the user even when there are so many different podcast covers, which take \n" +
        "a lot of attention.",
      "titleImageUnder": podsuxdesignimageunder
    },
    "uxUiDesignWide": {
      titleTextColor: "#FFFFFF",
      bannerImages: [
        {
          image: "/static/img/costumers/Pods/bannerimages/screen1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/Pods/bannerimages/screen2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Pods/bannerimages/screen3.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Pods/bannerimages/screen4.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Pods/bannerimages/screen5.png",
          isActive: false
        }],
      bannerMobileImages: [
        {
          image: "/static/img/costumers/Pods/bannerimages/mobile/screen1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/Pods/bannerimages/mobile/screen2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Pods/bannerimages/mobile/screen3.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Pods/bannerimages/mobile/screen4.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Pods/bannerimages/mobile/screen5.png",
          isActive: false
        }],
      middleBanner: {
        backgroundColor: "#f2f2f2",
        imageWeb: "/static/img/costumers/Pods/ux_section.svg",
        imageMobile: "/static/img/costumers/Pods/ux_section_mobile.svg",
        titleText: " UX DESIGN",
        titleColor: "#514077",
        text: "After researching, we realized that the average podcast's persona spend 1 hour top each day in listening to podcasts, mostly in his spare time. He love to expand his podcasts subjects from time to time. Equipped with this knowledge, we decided to make the user get his podcasts as quick as he can and let him organize his podcasts the way he want. Although give him the choice to be surprise from new podcasts in different territories.  ",
        textColor: "#414141"
      },
      "backgroundColor": "#2b2b32",
      "title": " UI DESIGN",
      "titleColor": "#f2b761",
      "textAboveImage": "",
      "text": "Like vinyl and cd covers, Podcast maker love their podcast covers. \n" +
        "There are many kind of podcast covers, most of them are very artistic, its make the visual of podcasts very special. When we started to design the App, we wanted to emphasize the entertainment of listening to podcast. The challenge was to stay simple and clear to the user even when there are so many different podcast covers, which take a lot of attention. ",
      "textUnderImage": "",
      "images": [],
      "colorNew": "",
      "image": ""

    },
    "uiDesignWide": {
      "backgroundColor": "",
      "images": "",
      "colorNew": "",
      "image": ""
    },
    "icons": {
      "iconsImage": podsiconsimage,
      "backgroundColor": "#161619",
      "iconsTitleColor": "#f2b761"
    },
    "footer": {
      "footerbackgroundimage": podsfooterbackground,
      "footermobilebackgroundimage": podsfootermobilebackground
    },
    "projectCover": {
      "projectCoverBackgroundImage": podsprojectcoverbackgroundimage,
      projectCoverBackgroundImageLogo: require ("../static/img/costumers/Pods/banner-logo.svg"),
      "projectCoverBackgroundMobileImage": podsprojectcoverbackgroundmobileimage,
      "projectCoverUpBanner": require("../static/img/costumers/Pods/mobilefull.png")
    }
  }, //10
  {
    "projectName": "WITH",
    image: require("../static/img/costumers/With/with.png"),
    imageMobile: require("../static/img/costumers/With/withm.png"),
    hoverImage: require("../static/img/costumers/With/withcover.png"),
    logo: require("../static/img/costumers/With/mobileproject.png"),
    isActive: false,
    "headerComponent": {
      "headerBackgroundImage": withbg,
      "headerMobileBackgroundImage": withmobilebg,
      "headerMobileBackgrounColor": "#112744"
    },
    "descriptionComponent": {
      "descriptionBackgroundColor": "#112744",
      "descriptionTitle": "WHO’S AT THE DOOR?",
      "descriptionTitleColor": "#40bfa6",
      "descriptionSubTitle": "Brings your home outdoors in your mobile",
      "descriptionText": "Second phase to a real-time video and audio door viewer app allowing you to see who is at your door from everywhere you are, using your phone",
      "platforms": " #UX­ #UI design #Android #iOS #LOGO",
      "descriptionImage": withdescriptionimage
    },
    "uxDesign": {
      "backgroundColor": "#1c4681",
      "titleColor": "#40bfa6",
      "uxDesignImage": withuxdesignimage,
      "uxDesignMobileImage": withuxdesignmobileimage,
      "titleImageAbove": withuxdesignimageabove,
      "uxDesignText": "Our main goal was to create a lean and friendly flow for the onboarding and an instant ‘live view’ button that can immediately connect the user to his door camera and decide how to proceed. We understand the importance of user’s privacy and the sense of control and security from anywhere.",
      "titleImageUnder": withuxdesignimageunder
    },
    "uiDesign": {
      "backgroundColorLeft": "#0f2747",
      "backgroundColorRight": "#163764",
      "titleUi": "UI",
      "titleColor": '#40bfa6',
      "uiDesignImages": [
        withuidesignimage
      ],
      "uiDesignMobileImages": [
        withuidesignmobileimage
      ],
      "colorNew": "#40bfa6",
      "image": withuidesignarrowimagenew,
      "titleImageAbove": withuxdesignimageabove,
      "uiDesignText": "In the design process we focused on giving sense of security when selecting the app color and design language. We added simple outlined icons and minimum “noise” so user can focus in the app’s purpose.",
      "titleImageUnder": withuxdesignimageunder
    },
    "uxUiDesignWide": {
      titleTextColor: "#FFFFFF",
      bannerImages: [
        {
          image: "/static/img/costumers/With/bannerimages/phone1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/With/bannerimages/phone2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/With/bannerimages/phone3.png",
          isActive: false
        }],
      bannerMobileImages: [
        {
          image: "/static/img/costumers/With/bannerimages/mobile/phone1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/With/bannerimages/mobile/phone2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/With/bannerimages/mobile/phone3.png",
          isActive: false
        }],
      middleBanner: {
        backgroundColor: "#f2f2f2",
        imageWeb: "/static/img/costumers/With/ux_section.svg",
        imageMobile: "/static/img/costumers/With/ux_section_mobile.svg",
        titleText: " UX DESIGN",
        titleColor: "#514077",
        text: "Our main goal was to create a lean and friendly flow for the onboarding and an instant ‘live view’ button that can immediately connect the user to his door camera and decide how to proceed. We understand the importance of user’s privacy and the sense of control and security from anywhere.",
        textColor: "#414141"
      },
      "backgroundColor": "#163764",
      "title": " UI DESIGN",
      "titleColor": "#40bfa6",
      "textAboveImage": "",
      "text": "In the design process we focused on giving sense of security when selecting the app color and design language. We added simple outlined icons and minimum “noise” so user can focus in the app’s purpose.",
      "textUnderImage": "",
      "images": [],
      "colorNew": "",
      "image": ""

    },
    "uiDesignWide": {
      "backgroundColor": "",
      "images": "",
      "colorNew": "",
      "image": ""
    },
    "icons": {
      "iconsImage": "",
      "backgroundColor": "",
      "iconsTitleColor": ""
    },
    "footer": {
      "footerbackgroundimage": withfooterbackground,
      "footermobilebackgroundimage": withfootermobilebackground
    },
    "projectCover": {
      "projectCoverBackgroundImage": withprojectcoverbackgroundimage,
      projectCoverBackgroundImageLogo: require ("../static/img/costumers/With/banner-logo.svg"),
      "projectCoverBackgroundMobileImage": withprojectcoverbackgroundmobileimage,
      "projectCoverUpBanner": require("../static/img/costumers/With/mobilefull.png")
    }
  }, //8
  {
    "projectName": "gotit",
    image: require("../static/img/costumers/GotIt/gotit.png"),
    imageMobile: require("../static/img/costumers/GotIt/gotitm.png"),
    hoverImage: require("../static/img/costumers/GotIt/gotitcover.png"),
    logo: require("../static/img/costumers/GotIt/mobileproject.png"),
    isActive: false,
    "headerComponent": {
      "headerBackgroundImage": gotitbg,
      "headerMobileBackgroundImage": gotitmobilebg,
      "headerMobileBackgrounColor": "#8f2339"
    },
    "descriptionComponent": {
      "descriptionBackgroundColor": "#8f2339",
      "descriptionTitle": "Enjoy the social experience while shopping",
      "descriptionTitleColor": "#ff3b75",
      "descriptionSubTitle": "Social shopping",
      "descriptionText": "GOTit  is a social network that allows users to enjoy the social experience \n" +
        "while shopping. GOTit lets the users connect to the brands they like, see what \n" +
        "their friends got and share their latest purchase.",
      "platforms": "#UX  #UI design  #iOS",
      "descriptionImage": gotitdescriptionimage
    },
    "uxDesign": {
      "backgroundColor": "#6e1a2b",
      "titleColor": "#ff3b75",
      "uxDesignImage": gotituxdesignimage,
      "uxDesignMobileImage": gotituxdesignmobileimage,
      "titleImageAbove": gotituxdesignimageabove,
      "uxDesignText": "When we started planning the structure of GOTit, we understood that combining an ecommerce site with a social network generates a lot of information and functions that need to be placed correctly on the app screens, avoiding overload. To overcome the information load we used a simple menu, an intuitive flow, icons to guide the user, and an easy to learn structure.",
      "titleImageUnder": gotituxdesignimageabove
    },
    "uiDesign": {
      "backgroundColorLeft": "#95283e",
      "backgroundColorRight": "#7e2033",
      "titleUi": "UI",
      "titleColor": '#f3386e',
      "uiDesignImages": [
        gotituidesignimage
      ],
      "uiDesignMobileImages": [
        gotituidesignmobileimage
      ],
      "colorNew": "#f3386e",
      "image": gotituidesignarrowimagenew,
      "titleImageAbove": gotituxdesignimageabove,
      "uiDesignText": "Most of the design is with a map and display the different possibilities and cases. We knew we are dealing with users that most of them are not familiar with technology and the modern world. Also we took in consideration that this app is worldwide, so we made a lean design with generic icons as possible and focused on conveying the information as quickly and clearly as possible.",
      "titleImageUnder": gotituxdesignimageabove
    },
    "uxUiDesignWide": {
      "backgroundColor": "#95283e",
      "title": " UI DESIGN",
      "titleColor": "#ff3b75",
      "textAboveImage": "",
      "text": "Most of the design is with a map and display the different possibilities and cases. We knew we are dealing with users that most of them are not familiar with technology and the modern world. Also we took in consideration that this app is worldwide, so we made a lean design with generic icons as possible and focused on conveying the information as quickly and clearly as possible.",
      "textUnderImage": "",
      "images": [],
      "colorNew": "",
      "image": "",
      titleTextColor: "#FFFFFF",
      bannerImages: [
        {
          image: "/static/img/costumers/GotIt/bannerimages/phone1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/GotIt/bannerimages/phone2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/GotIt/bannerimages/phone3.png",
          isActive: false
        }, {
          image: "/static/img/costumers/GotIt/bannerimages/phone4.png",
          isActive: false
        }, {
          image: "/static/img/costumers/GotIt/bannerimages/phone5.png",
          isActive: false
        }],
      bannerMobileImages: [
        {
          image: "/static/img/costumers/GotIt/bannerimages/mobile/phone1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/GotIt/bannerimages/mobile/phone2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/GotIt/bannerimages/mobile/phone3.png",
          isActive: false
        }, {
          image: "/static/img/costumers/GotIt/bannerimages/mobile/phone4.png",
          isActive: false
        }, {
          image: "/static/img/costumers/GotIt/bannerimages/mobile/phone5.png",
          isActive: false
        }],
      middleBanner: {
        backgroundColor: "#f2f2f2",
        imageWeb: "/static/img/costumers/GotIt/ux_section.svg",
        imageMobile: "/static/img/costumers/GotIt/ux_section_mobile.svg",
        titleText: " UX DESIGN",
        titleColor: "#514077",
        text: "When we started planning the structure of GOTit, we understood that combining an ecommerce site with a social network generates a lot of information and functions that need to be placed correctly on the app screens, avoiding overload. To overcome the information load we used a simple menu, an intuitive flow, icons to guide the user, and an easy to learn structure",
        textColor: "#414141"
      },
    },
    "uiDesignWide": {
      "backgroundColor": "",
      "images": "",
      "colorNew": "",
      "image": ""
    },
    "icons": {
      "iconsImage": "",
      "backgroundColor": "",
      "iconsTitleColor": ""
    },
    "footer": {
      "footerbackgroundimage": gotitfooterbackground,
      "footermobilebackgroundimage": gotitfootermobilebackground
    },
    "projectCover": {
      "projectCoverBackgroundImage": gotitprojectcoverbackgroundimage,
      projectCoverBackgroundImageLogo: require ("../static/img/costumers/GotIt/banner-logo.svg"),
      "projectCoverBackgroundMobileImage": gotitprojectcoverbackgroundmobileimage,
      "projectCoverUpBanner": require("../static/img/costumers/GotIt/mobilefull.png")
    }
  }, //7
  {
    "projectName": "probuild",
    image: require("../static/img/costumers/Probuild/probuild.png"),
    imageMobile: require("../static/img/costumers/Probuild/probuildm.png"),
    hoverImage: require("../static/img/costumers/Probuild/probuildcover.png"),
    logo: require("../static/img/costumers/Probuild/mobileproject.png"),
    isActive: false,
    "headerComponent": {
      "headerBackgroundImage": probuildbg,
      "headerMobileBackgroundImage": probuildmobilebg,
      "headerMobileBackgrounColor": "#1a384e"
    },
    "descriptionComponent": {
      "descriptionBackgroundColor": "#1a384e",
      "descriptionTitle": "PROBUILD SYSTEM",
      "descriptionTitleColor": "#c2edff",
      "descriptionSubTitle": "ERP system",
      "descriptionText": "Project management and ERP for large scale construction projects. Probuild is an ongoing project.",
      "platforms": "#UX/UI design  #android #iOS #tablet #desktop",
      "descriptionImage": probuilddescriptionimage
    },
    "uiDesign": {
      "backgroundColorLeft": "#214763",
      "backgroundColorRight": "#2b5f85",
      "titleUi": "UX/UI",
      "titleColor": '#c2edff',
      "uiDesignImages": [
        probuilduidesignimage
      ],
      "uiDesignMobileImages": [
        probuilduidesignmobileimage
      ],
      "colorNew": "#c2edff",
      "image": probuilduidesignarrowimagenew,
      "titleImageAbove": probuilduxdesignimageabove,
      "uiDesignText": "The biggest challenge in Probuild system, was to take enormous amount of data and make it accessible for all the users, from the worker in the project field through the administration man/woman in the office. The user navigation inside the system, must happen easly and fast and all the system verity parts have to be Synchronized.",
      "titleImageUnder": probuilduxdesignimageunder
    },
    "uxUiDesignWide": {
      titleTextColor: "#FFFFFF",
      bannerImages: [
        {
          image: "/static/img/costumers/Probuild/bannerimages/comp1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/Probuild/bannerimages/comp2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Probuild/bannerimages/tablet.png",
          isActive: false
        }],
      bannerMobileImages: [
        {
          image: "/static/img/costumers/Probuild/bannerimages/mobile/comp1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/Probuild/bannerimages/mobile/comp2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Probuild/bannerimages/mobile/tablet.png",
          isActive: false
        }],
      "backgroundColor": "#2b5f85",
      "title": "UX/UI DESIGN",
      "titleColor": "#c2edff",
      "textAboveImage": "",
      "text": "The biggest challenge in Probuild system, was to take enormous amount of data \n" +
        "and make it accessible for all the users, from the worker in the project field through the administration man/woman in the office. The user navigation inside the system, must happen easly and fast and all the system verity parts have to be Synchronized.",
      "textUnderImage": "",
      "images": [],
      "colorNew": "",
      "image": ""

    },
    "uiDesignWide": {
      "backgroundColor": "",
      "images": "",
      "colorNew": "",
      "image": ""
    },
    "icons": {
      "iconsImage": "",
      "backgroundColor": "",
      "iconsTitleColor": ""
    },
    "footer": {
      "footerbackgroundimage": probuildfooterbackground,
      "footermobilebackgroundimage": probuildfootermobilebackground
    },
    "projectCover": {
      "projectCoverBackgroundImage": probuildprojectcoverbackgroundimage,
      projectCoverBackgroundImageLogo: require ("../static/img/costumers/Probuild/banner-logo.svg"),
      "projectCoverBackgroundMobileImage": probuildprojectcoverbackgroundmobileimage,
      "projectCoverUpBanner": require("../static/img/costumers/Probuild/mobilefull.png")
    }
  }, //3
  {
    "projectName": "maytronics",
    image: require("../static/img/costumers/mytronics/mytronics.png"),
    imageMobile: require("../static/img/costumers/mytronics/mytronicsm.png"),
    hoverImage: require("../static/img/costumers/mytronics/mytronicscover.png"),
    logo: require("../static/img/costumers/mytronics/mobileproject.png"),
    isActive: false,
    "headerComponent": {
      "headerBackgroundImage": maytronicsbg,
      "headerMobileBackgroundImage": maytronicsmobilebg,
      "headerMobileBackgrounColor": "#1c5460"
    },
    "descriptionComponent": {
      "descriptionBackgroundColor": "#1c5460",
      "descriptionTitle": "POOL CLEANING ROBOT",
      "descriptionTitleColor": "#58c8df",
      "descriptionSubTitle": "Pool cleaning robot",
      "descriptionText": "Maytronics is the largest manufacture of pool cleaning robots. With this easy-to-use app you can register your Dolphin robot pool cleaner online and control it remotely.",
      "platforms": "#UX­ #UI Design #iOS #android",
      "descriptionImage": maytronicsdescriptionimage
    },
    "uiDesign": {
      "backgroundColorLeft": "#20606e",
      "backgroundColorRight": "#2b7a8b",
      "titleUi": "UX/UI",
      titleColor: '#58c8df',
      "uiDesignImages": [
        maytronicsuidesignimage
      ],
      "uiDesignMobileImages": [
        maytronicsuidesignmobileimage
      ],
      colorNew: "#58c8df",
      "image": maytronicsuidesignarrowimagenew,
      "titleImageAbove": maytronicsuxdesignimageabove,
      "uiDesignText": "We created an  app that her main purpose is to be easy to use and to remote control from anywhere. With the help on illustrations and easy steps we created a small learning curve to help user to setup his robot, activate cleaning programs and the weekly timer, navigate manually and take advantage of every possible option.\n" +
        "We designed a clean interface with light gray and bright colors to give the sense of control, friendly and simple, yet professional with high technology product app.",
      "titleImageUnder": maytronicsuxdesignimageabove
    },
    "uxUiDesignWide": {
      titleTextColor: "#FFFFFF",
      bannerImages: [
        {
          image: "/static/img/costumers/mytronics/bannerimages/phone1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/mytronics/bannerimages/phone2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/mytronics/bannerimages/phone3.png",
          isActive: false
        }],
      bannerMobileImages: [
        {
          image: "/static/img/costumers/mytronics/bannerimages/mobile/phone1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/mytronics/bannerimages/mobile/phone2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/mytronics/bannerimages/mobile/phone3.png",
          isActive: false
        }],
      titleColor: "#58c8df",
      "backgroundColor": "#2b7a8b",
      "title": "UX/UI DESIGN",

      "textAboveImage": "",
      "text": "We created an app that her main purpose is to be easy to use and to remote control from anywhere. With the help on illustrations and easy steps we created a small learning curve to help user to setup his robot, activate cleaning programs and the weekly timer, navigate manually and take advantage of every possible option.",
      "textUnderImage": "",
      "images": [],
      "colorNew": "",
      "image": ""

    },
    "uiDesignWide": {
      "backgroundColor": "",
      "images": "",
      "colorNew": "",
      "image": ""
    },
    "icons": {
      "iconsImage": "",
      "backgroundColor": "",
      "iconsTitleColor": ""
    },
    "footer": {
      "footerbackgroundimage": maytronicsfooterbackground,
      "footermobilebackgroundimage": maytronicsfootermobilebackground
    },
    "projectCover": {
      "projectCoverBackgroundImage": maytronicsprojectcoverbackgroundimage,
      projectCoverBackgroundImageLogo: require ("../static/img/costumers/mytronics/banner-logo.svg"),
      "projectCoverBackgroundMobileImage": maytronicsprojectcoverbackgroundmobileimage,
      "projectCoverUpBanner": require("../static/img/costumers/mytronics/mobilefull.png")
    }
  }, //1
  {
    "projectName": "tiivii",
    image: require("../static/img/costumers/TiiVii/tiivii.png"),
    imageMobile: require("../static/img/costumers/TiiVii/tiiviim.png"),
    hoverImage: require("../static/img/costumers/TiiVii/tiiviicover.png"),
    logo: require("../static/img/costumers/TiiVii/mobileproject.png"),
    isActive: false,
    "headerComponent": {
      "headerBackgroundImage": tiiviibg,
      "headerMobileBackgroundImage": tiiviimobilebg,
      "headerMobileBackgrounColor": "#1b1a1a"
    },
    "descriptionComponent": {
      "descriptionBackgroundColor": "#414041",
      "descriptionTitle": "REMOTE PRODUCTION",
      "descriptionTitleColor": "#e84740",
      "descriptionSubTitle": "Remote production",
      "descriptionText": "Cloud platform for low cost self-production of video events at venues. the main feature of this multicamera interface is the camera change speed (zero latency on user interaction) and also manually select camera angles and movements, zooms and graphics.",
      "platforms": "#UX­ #UI design #Android #iOS",
      "descriptionImage": tiiviidescriptionimage
    },
    "uxDesign": {
      "backgroundColor": "#252323",
      "titleColor": "#e84740",
      "uxDesignImage": tiiviiuxdesignimage,
      "uxDesignMobileImage": tiiviiuxdesignmobileimage,
      "titleImageAbove": tiiviiuxdesignimageabove,
      "uxDesignText": "The objectives were really challenging. First of all, different target audiences that addressed under a single platform and also different permissions, keeping users active and engaged, having users to comment and manage content, yet protecting their privacy and preventing unappropriate content, give focus to real-time game watching experience and also have the social network the same time without disturbing. Creating a unique user experience for each audience tailored to his needs, yet maintaining consistency in the overall level of experience and the look and feel.",
      "titleImageUnder": tiiviiuxdesignimageabove
    },
    "uiDesign": {
      "backgroundColorLeft": "#1b1919",
      "backgroundColorRight": "#2f2c2c",
      "titleUi": "UI",
      "titleColor": '#e84740',
      "uiDesignImages": [
        tiiviiuidesignimage
      ],
      "uiDesignMobileImages": [
        tiiviiuidesignmobileimage
      ],
      "colorNew": "#e84740",
      "image": tiiviiuidesignarrowimagenew,
      "titleImageAbove": tiiviiuxdesignimageabove,
      "uiDesignText": "We collected different references from video and social world and tried to find the right look and feel that suits both. We created a unique graphic with their own icon sets and creative empty states.",
      "titleImageUnder": tiiviiuxdesignimageabove
    },
    "uxUiDesignWide": {
      titleTextColor: "#f2f2f2",
      bannerImages: [
        {
          image: "/static/img/costumers/TiiVii/bannerimages/phone1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/TiiVii/bannerimages/phone2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/TiiVii/bannerimages/phone3.png",
          isActive: false
        }, {
          image: "/static/img/costumers/TiiVii/bannerimages/phone4.png",
          isActive: false
        }, {
          image: "/static/img/costumers/TiiVii/bannerimages/phone5.png",
          isActive: false
        }],
      bannerMobileImages: [
        {
          image: "/static/img/costumers/TiiVii/bannerimages/mobile/phone1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/TiiVii/bannerimages/mobile/phone2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/TiiVii/bannerimages/mobile/phone3.png",
          isActive: false
        }, {
          image: "/static/img/costumers/TiiVii/bannerimages/mobile/phone4.png",
          isActive: false
        }, {
          image: "/static/img/costumers/TiiVii/bannerimages/mobile/phone5.png",
          isActive: false
        }],
      middleBanner: {
        backgroundColor: "#f2f2f2",
        imageWeb: "/static/img/costumers/TiiVii/ux_section.svg",
        imageMobile: "/static/img/costumers/TiiVii/ux_section_mobile.svg",
        titleText: " UX DESIGN",
        titleColor: "#514077",
        text: "The objectives were really challenging. First of all, different target audiences that addressed under a single platform and also different permissions, keeping users active and engaged, having users to comment and manage content, yet protecting their privacy and preventing unappropriate content, give focus to real-time game watching experience and also have the social network the same time without disturbing. Creating a unique user experience for each audience tailored to his needs, yet maintaining consistency in the overall level of experience and the look and feel.",
        textColor: "#414141"
      },

      "backgroundColor": "#2f2c2c",
      "title": " UI DESIGN",
      "titleColor": "#e84740",
      "textAboveImage": "",
      "text": "What guided us when we started designing concepts for GreenIQ, was the importance \n" +
        "of keeping it simple and practical, yet adding a fresh look  which strengthens the application's essence. We directed user’s focus in app’s activities and actions, maintaining a tailor made warm experience using photos and creating programs in all platforms.",
      "textUnderImage": "",
      "images": [],
      "colorNew": "",
      "image": ""

    },
    "uiDesignWide": {
      "backgroundColor": "",
      "images": "",
      "colorNew": "",
      "image": ""
    },
    "icons": {
      "iconsImage": "",
      "backgroundColor": "",
      "iconsTitleColor": ""
    },
    "footer": {
      "footerbackgroundimage": tiiviifooterbackground,
      "footermobilebackgroundimage": tiiviifootermobilebackground
    },
    "projectCover": {
      "projectCoverBackgroundImage": tiiviiprojectcoverbackgroundimage,
      projectCoverBackgroundImageLogo: require ("../static/img/costumers/TiiVii/banner-logo.svg"),
      "projectCoverBackgroundMobileImage": tiiviiprojectcoverbackgroundmobileimage,
      "projectCoverUpBanner": require("../static/img/costumers/TiiVii/mobilefull.png")
    }
  }, //6
  {
    "projectName": "telll",
    image: require("../static/img/costumers/Telll/telll.png"),
    imageMobile: require("../static/img/costumers/Telll/telllm.png"),
    hoverImage: require("../static/img/costumers/Telll/telllcover.png"),
    logo: require("../static/img/costumers/Telll/mobileproject.png"),
    isActive: false,
    "headerComponent": {
      "headerBackgroundImage": telllbg,
      "headerMobileBackgroundImage": telllmobilebg,
      "headerMobileBackgrounColor": "#3d0311"
    },
    "descriptionComponent": {
      "descriptionBackgroundColor": "#3d0311",
      "descriptionTitle": "DIFFERENT KIND OF ECOMMERCE",
      "descriptionTitleColor": "#fea301",
      "descriptionSubTitle": "Smart Garden Hub",
      "descriptionText": "Telll makes it easy for users to meanungfully interact with brands and experiences they love by enriching the content they consume.",
      "platforms": "#UX #UI design #branding  #Android #iOS #desktop #LOGO",
      "descriptionImage": tellldescriptionimage
    },
    "uxDesign": {
      "backgroundColor": "#760c26",
      "titleColor": "#fea301",
      "uxDesignImage": tellluxdesignimage,
      "uxDesignMobileImage": tellluxdesignmobileimage,
      "titleImageAbove": tellluxdesignimageabove,
      "uxDesignText": "When working on GreenIQ, we put emphasis on creating flow and learning curve easy and intuitive as can be, focusing on providing the sense of control to the user. The application is very intuitive, pleasant, allowing the user to control the irrigation system at home, and get immediate information at any time without any effort from anywhere.",
      "titleImageUnder": tellluxdesignimageabove
    },
    "uiDesign": {
      "backgroundColorLeft": "#690b22",
      "backgroundColorRight": "#971132",
      "titleUi": "UI",
      "titleColor": '#fea301',
      "uiDesignImages": [
        tellluidesignimage
      ],
      "uiDesignMobileImages": [
        tellluidesignmobileimage
      ],
      "colorNew": "#fea301",
      "image": tellluidesignarrowimagenew,
      "titleImageAbove": tellluxdesignimageabove,
      "uiDesignText": "What guided us when we started designing concepts for GreenIQ, was the importance of keeping it simple and practical, yet adding a fresh look  which strengthens the application's essence. We directed user’s focus in app’s activities and actions, maintaining a tailor made warm experience using photos and creating programs in all platforms.",
      "titleImageUnder": tellluxdesignimageabove
    },
    "uxUiDesignWide": {
      titleTextColor: "#ffffff",
      bannerImages: [
        {
          image: "/static/img/costumers/Telll/bannerimages/phone1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/Telll/bannerimages/phone2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Telll/bannerimages/phone3.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Telll/bannerimages/phone4.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Telll/bannerimages/phone5.png",
          isActive: false
        }],
      bannerMobileImages: [
        {
          image: "/static/img/costumers/Telll/bannerimages/mobile/phone1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/Telll/bannerimages/mobile/phone2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Telll/bannerimages/mobile/phone3.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Telll/bannerimages/mobile/phone4.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Telll/bannerimages/mobile/phone5.png",
          isActive: false
        }],
      middleBanner: {
        backgroundColor: "#f2f2f2",
        imageWeb: "/static/img/costumers/Telll/ux_section.svg",
        imageMobile: "/static/img/costumers/Telll/ux_section_mobile.svg",
        titleText: " UX DESIGN",
        titleColor: "#514077",
        text: "We loved the technology and concept of this project from the start. We helped define solutions to different challanges from managing the content adviser, user’s shopping online experience and legal issues to all it main concern. We built a complex flow for entering content for each advertiser, yet fluid and easy to learn and understand.",
        textColor: "#414141"
      },
      "backgroundColor": "#971132",
      "title": " UI DESIGN",
      "titleColor": "#fea301",
      "textAboveImage": "",
      "text": "In our designed we try to preserve grids from familiar media players for users to feel comfortable and in control. Within those boundries we combined our unique graphic bold language and the product - Tellinks, and implemented in all platforms.",
      "textUnderImage": "",
      "images": [],
      "colorNew": "",
      "image": ""

    },
    "uiDesignWide": {
      "backgroundColor": "",
      "images": "",
      "colorNew": "",
      "image": ""
    },
    "icons": {
      "iconsImage": "",
      "backgroundColor": "",
      "iconsTitleColor": ""
    },
    "footer": {
      "footerbackgroundimage": telllfooterbackground,
      "footermobilebackgroundimage": telllfootermobilebackground
    },
    "projectCover": {
      "projectCoverBackgroundImage": telllprojectcoverbackgroundimage,
      projectCoverBackgroundImageLogo: require ("../static/img/costumers/Telll/banner-logo.svg"),
      "projectCoverBackgroundMobileImage": telllprojectcoverbackgroundmobileimage,
      "projectCoverUpBanner": require("../static/img/costumers/Telll/mobilefull.png")
    }
  }, //4
  {
    "projectName": "Cattle watch",
    image: require("../static/img/costumers/Cattle/cattle-watch.png"),
    imageMobile: require("../static/img/costumers/Cattle/cattleWatchm.png"),
    hoverImage: require("../static/img/costumers/Cattle/cattlecover.png"),
    logo: require("../static/img/costumers/Cattle/mobileproject.png"),
    isActive: false,
    "headerComponent": {
      "headerBackgroundImage": cattleWatchbg,
      "headerMobileBackgroundImage": cattlewatchmobilebg,
      "headerMobileBackgrounColor": "#203b13"
    },
    "descriptionComponent": {
      "descriptionBackgroundColor": "#203b13",
      "descriptionTitle": "Cattle watch",
      "descriptionTitleColor": "#6cbd45",
      "descriptionSubTitle": "Taking care of your herd",
      "descriptionText": "The collars on the cattle transmit informations to help the herdman manage his herd better in many ways as: the system counts the herd all time so no cattle is missed, geo-fence, sms for alerts such as attempt to cut or remove the collar or attack the cattle, location and ID for every cattle, cattle physiological behavior and cattle finder and navigation to her location.",
      "platforms": " #UX­ #UI design #Android #prototype",
      "descriptionImage": cattleWatchdescriptionimage
    },
    "uxDesign": {
      "backgroundColor": "#3d6f25",
      "titleColor": "#6cbd45",
      "uxDesignImage": cattleWatchuxdesignimage,
      "uxDesignMobileImage": cattleWatchuxdesignmobileimage,
      "titleImageAbove": cattleWatchuxdesignimageabove,
      "uxDesignText": "Well that was an unusual and fun project that revealed us to many interesting facts about catlle’s behavior and herdsman responsibilities and the importance of such an app.  The research had an important role cause that was an unfamiliar subject. We talked a lot with herdsmans from Africa and technology people that built the collar to understand the possibilities and design all the possible scenarios and provide solutions. ",
      "titleImageUnder": cattleWatchuxdesignimageabove
    },
    "uiDesign": {
      "backgroundColorLeft": "#2a4e19",
      "backgroundColorRight": "#427a28",
      "titleUi": "UI",
      "titleColor": '#6cbd45',
      "uiDesignImages": [
        cattleWatchuidesignimage
      ],
      "uiDesignMobileImages": [
        cattleWatchuidesignmobileimage
      ],
      "colorNew": "#6cbd45",
      "image": cattleWatchuidesignarrowimagenew,
      "titleImageAbove": cattleWatchuxdesignimageabove,
      "uiDesignText": "Most of the design is with a map and display the different possibilities and cases. We knew we are dealing with users that most of them are not familiar with technology and the modern world. Also we took in consideration that this app is worldwide, so we made a lean design with generic icons as possible and focused on conveying the information as quickly and clearly as possible.",
      "titleImageUnder": cattleWatchuxdesignimageabove
    },
    "uxUiDesignWide": {
      titleTextColor: "#dddddd",
      bannerImages: [
        {
          image: "/static/img/costumers/Cattle/bannerimages/screen1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/Cattle/bannerimages/screen2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Cattle/bannerimages/screen3.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Cattle/bannerimages/screen4.png",
          isActive: false
        }],
      middleBanner: {
        backgroundColor: "#f2f2f2",
        imageWeb: "/static/img/costumers/Cattle/ux_section.svg",
        imageMobile: "/static/img/costumers/Cattle/ux_section_mobile.svg",
        titleText: " UX DESIGN",
        titleColor: "#514077",
        text: "Well that was an unusual and fun project that revealed us to many interesting facts about catlle’s behavior and herdsman responsibilities and the importance of such an app. The research had an important role ‘cause that was an unfamiliar subject. We talked a lot with herdsmans from Africa and technology people that built the collar to understand the possibilities and design all the possible scenarios and provide solutions.  ",
        textColor: "#414141"
      },
      bannerMobileImages: [
        {
          image: "/static/img/costumers/Cattle/bannerimages/mobile/phone1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/Cattle/bannerimages/mobile/phone2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/Cattle/bannerimages/mobile/phone3.png",
          isActive: false
        }],
      "backgroundColor": "#427a28",
      "title": " UI DESIGN",
      "titleColor": "#6cbd45",
      "textAboveImage": "",
      "text": "Most of the design is with a map and display the different possibilities and cases. We knew we are dealing with users that most of them are not familiar with technology and the modern world. Also we took in consideration that this app is worldwide, so we made a lean design with generic icons as possible and focused on conveying the information as quickly and clearly as possible.",
      "textUnderImage": "",
      "images": [],
      "colorNew": "",
      "image": ""

    },
    "uiDesignWide": {
      "backgroundColor": "",
      "images": "",
      "colorNew": "",
      "image": ""
    },
    "icons": {
      "iconsImage": "",
      "backgroundColor": "",
      "iconsTitleColor": ""
    },
    "footer": {
      "footerbackgroundimage": cattleWatchfooterbackground,
      "footermobilebackgroundimage": cattleWatchfootermobilebackground
    },
    "projectCover": {
      "projectCoverBackgroundImage": cattlewatchprojectcoverbackgroundimage,
      "projectCoverBackgroundMobileImage": cattlewatchprojectcoverbackgroundmobileimage,
      projectCoverBackgroundImageLogo: require ("../static/img/costumers/Cattle/banner-logo.svg"),
      "projectCoverUpBanner": require("../static/img/costumers/Cattle/mobilefull.png")
    }
  }, //11
  {
    "projectName": "israelToday",
    image: require("../static/img/costumers/IsraelToday/israel-today.png"),
    imageMobile: require("../static/img/costumers/IsraelToday/israelTodaym.png"),
    hoverImage: require("../static/img/costumers/IsraelToday/isarelcover.png"),
    logo: require("../static/img/costumers/IsraelToday/mobileproject.png"),
    isActive: false,
    "headerComponent": {
      "headerBackgroundImage": israelTodaybg,
      "headerMobileBackgroundImage": israeltodaymobilebg,
      "headerMobileBackgrounColor": "#151517"
    },
    "descriptionComponent": {
      "descriptionBackgroundColor": "#151517",
      "descriptionTitle": "NEWSPAPER APP",
      "descriptionTitleColor": "#ffffff",
      "descriptionSubTitle": "newspaper app",
      "descriptionText": "Israel Hayom is Israel's leading daily news agency in terms of circulation.\n" +
        "The Israel Hayom app is a the publisher's leading point of contact with its readers on the mobile platform. Built as a fully native application, the app boasts a fluid navigation flow designed to present a unique and relatable experience.",
      "platforms": "#UX­ #UI Design #iOS #android",
      "descriptionImage": ""
    },
    "uiDesign": {
      "colorNew": "#ffffff",
      "image": israelTodayuidesignarrowimagenew,
    },
    "uxUiDesignWide": {
      titleTextColor: "#FFFFFF",
      bannerImages: [
        {
          image: "/static/img/costumers/IsraelToday/bannerimages/phone1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/IsraelToday/bannerimages/phone2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/IsraelToday/bannerimages/phone3.png",
          isActive: false
        }],
      bannerMobileImages: [
        {
          image: "/static/img/costumers/IsraelToday/bannerimages/mobile/phone1.png",
          isActive: true
        }, {
          image: "/static/img/costumers/IsraelToday/bannerimages/mobile/phone2.png",
          isActive: false
        }, {
          image: "/static/img/costumers/IsraelToday/bannerimages/mobile/phone3.png",
          isActive: false
        }],
      "backgroundColor": "#202024",
      "title": "UX/UI DESIGN",
      "titleColor": "#58c8df",
      "textAboveImage": "",
      "text": "The client tasked the team with creating a design reminiscence of glossy magazines.\n" +
        "The UI and UX are set to highlight the publisher's rich content and dramatic photographic assets. When the client begun focusing heavily on video content, so was the app upgraded with the ability to use videos as a backdrop in the main feed.We feel that we have proven that in today's climate of constant distractions and ״media market crisis\", a good design is key.  Indeed, ever since launch the app keeps performing exceptionally in terms of MAU, retention and time spent inside the app.",
      "textUnderImage": "",
      "images": [],
      "colorNew": "",
      "image": ""

    },
    "uiDesignWide": {
      "backgroundColor": "#202024",
      "images": [
        israelTodayuidesignimage
      ],
      "imagesMobile": [
        israelTodayuidesignmobileimage
      ],
      "colorNew": "#ffffff",
      "image": israelTodayuidesignarrowimagenew
    },
    "icons": {
      "iconsImage": "",
      "backgroundColor": "",
      "iconsTitleColor": ""
    },
    "footer": {
      "footerbackgroundimage": israelTodayfooterbackground,
      "footermobilebackgroundimage": israeltodayfootermobilebackground
    },
    "projectCover": {
      "projectCoverBackgroundImage": israelTodayprojectcoverbackgroundimage,
      projectCoverBackgroundImageLogo: require ("../static/img/costumers/IsraelToday/banner-logo.svg"),
      "projectCoverBackgroundMobileImage": israelTodayprojectcoverbackgroundmobileimage,
      "projectCoverUpBanner": require("../static/img/costumers/IsraelToday/mobilefull.png")
    }
  }, //2

]

export default data;



// WEBPACK FOOTER //
// ./src/projectsData.js